import { render } from "./ServerAdmin.vue?vue&type=template&id=1aab040b&scoped=true&ts=true"
import script from "./ServerAdmin.vue?vue&type=script&lang=ts"
export * from "./ServerAdmin.vue?vue&type=script&lang=ts"

import "./ServerAdmin.vue?vue&type=style&index=0&id=1aab040b&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aab040b"]])

export default __exports__